var map = {
	"./cranecloud.png": 4280,
	"./harmonic.png": 939,
	"./infinity.png": 3406,
	"./iras.png": 6699,
	"./mobileshop.png": 1484,
	"./naro.png": 5440,
	"./nema.png": 7447,
	"./tayari.png": 5102,
	"./waape.png": 1820,
	"./ziramba.png": 3082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 452;